import { wp } from '@/lib/api'
import { mapNavigations, type Navigation, type RawNavigation } from '@/models/navigation'
import type { Locale } from '@/router/locales'
import { get } from '@/services/http'

export const NavigationService = {
  async get(locale: Locale): Promise<Navigation[]> {
    const request = get<RawNavigation[]>(
      'navigations',
      { params: { lang: locale } },
      {
        client: wp,
        dedupe: true,
        retry: { retries: 2 },
      },
    )

    return mapNavigations(await request.promise, locale)
  },
}
